import React, { Component } from 'react'
import Icon from "../../../common/icon/icon.component.jsx";
import UserNameLabel from "../../../common/user/label.component.jsx";

class InternalNotesChangedEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
        })
    }


    render() {
        return <div className={"row " + this.state.className}>
            <div className={'col-12 d-flex '}>
                <div className={'mr-3'}>
                    <h3 className={"m-0"}>
                        <Icon value={"quote-right"} />
                    </h3>
                </div>
                <div className={'flex-grow-1'}>
                    <div className={'w-100 mt-1'}>
                        <blockquote className="blockquote mb-0 bg-light py-3">
                            <p className="mb-0">{this.state.object.attributes.notes.split('\n').map((item, key) => {
                                return <span key={key}>{item}<br /></span>
                            })}</p>
                            <footer className="blockquote-footer mt-2">
                                <UserNameLabel className={'strong'} value={this.state.object.attributes.updatedBy} />
                            </footer>
                        </blockquote>
                    </div>
                </div>
            </div>
        </div>
    }

}

export default InternalNotesChangedEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/internal-notes-changed.component.jsx